export function getCoordsByAttachMode(target, attachMode, scale) {
  let targetSize;
  let deltaX = 0;
  let deltaY = 0;

  if (target?.getAttr('elementType') === 'text') {
    const mode = target.getAttr('mode') || 'fixed';
    if (mode === 'flex') {
      const substrate = target.findOne('.substrate');
      if (substrate) {
        targetSize = substrate.getClientRect();
        deltaX = substrate.x();
        deltaY = substrate.y();
      } else {
        targetSize = target.getClientRect();
      }
    } else {
      const bgRect = target.findOne('.background');
      if (bgRect) {
        targetSize = bgRect.getClientRect();
        deltaX = bgRect.x();
        deltaY = bgRect.y();
      } else {
        targetSize = target.getClientRect();
      }
    }
  } else if (target?.getAttr('elementType') === 'image') {
    const imageNode = target.findOne('Image');
    const mode = imageNode?.getAttr('mode');
    const bgRect = target.findOne('.background');
    if (mode === 'flex' && bgRect) {
      targetSize = bgRect.getClientRect();
      deltaX = bgRect.x();
      deltaY = bgRect.y();
    } else {
      targetSize = target.getClientRect();
    }
  } else if (target) {
    targetSize = target.getClientRect();
  }

  if (!targetSize) return { x: deltaX, y: deltaY };

  const targetWidth = targetSize.width / scale.x;
  const targetHeight = targetSize.height / scale.y;

  switch (attachMode) {
    case '2': return { x: deltaX + targetWidth / 2, y: deltaY };
    case '3': return { x: deltaX + targetWidth, y: deltaY };
    case '4': return { x: deltaX, y: deltaY + targetHeight / 2 };
    case '5': return { x: deltaX + targetWidth / 2, y: deltaY + targetHeight / 2 };
    case '6': return { x: deltaX + targetWidth, y: deltaY + targetHeight / 2 };
    case '7': return { x: deltaX, y: deltaY + targetHeight };
    case '8': return { x: deltaX + targetWidth / 2, y: deltaY + targetHeight };
    case '9': return { x: deltaX + targetWidth, y: deltaY + targetHeight };
    default: return { x: deltaX, y: deltaY };
  }
}

export function getAttachedSourcePosition(target, attachMode, source, sourceAttachMode = '1', offsetX = 0, offsetY = 0) {
  if (!target || !source) return;
  const currentStage = target.getStage();
  if (!currentStage) return;
  const scale = { x: currentStage.scaleX(), y: currentStage.scaleY() };
  const sourceCoords = getCoordsByAttachMode(source, sourceAttachMode, scale);

  let baseX = target.x();
  let baseY = target.y();

  if (target.getAttr('elementType') === 'text') {
    const mode = target.getAttr('mode') || 'fixed';
    if (mode === 'flex') {
      const substrate = target.findOne('.substrate');
      if (substrate) { baseX += substrate.x(); baseY += substrate.y(); }
    } else {
      const bgRect = target.findOne('.background');
      if (bgRect) { baseX += bgRect.x(); baseY += bgRect.y(); }
    }
  }

  const imageMode = target.getAttr('elementType') === 'image'
    ? target.findOne('Image')?.getAttr('mode')
    : null;

  if (target.getAttr('elementType') === 'image' && imageMode === 'flex') {
    const bgRect = target.findOne('.background');
    if (bgRect) { baseX += bgRect.x(); baseY += bgRect.y(); }
  }

  const targetRef = target.getAttr('elementType') === 'text'
    ? (target.findOne('.substrate') || target.findOne('.background') || target)
    : (target.getAttr('elementType') === 'image' && imageMode === 'flex'
        ? (target.findOne('.background') || target)
        : target);

  const targetSize = targetRef.getClientRect();
  if (!targetSize) return;

  const targetWidth = targetSize.width / scale.x;
  const targetHeight = targetSize.height / scale.y;

  let defaultX = baseX + offsetX - sourceCoords.x;
  let defaultY = baseY + offsetY - sourceCoords.y;

  switch (attachMode) {
    case '1': return { x: defaultX, y: defaultY };
    case '2': return { x: defaultX + targetWidth / 2, y: defaultY };
    case '4': return { x: defaultX, y: defaultY + targetHeight / 2 };
    case '5': return { x: defaultX + targetWidth / 2, y: defaultY + targetHeight / 2 };
    case '6': return { x: defaultX + targetWidth, y: defaultY + targetHeight / 2 };
    case '7': return { x: defaultX, y: defaultY + targetHeight };
    case '8': return { x: defaultX + targetWidth / 2, y: defaultY + targetHeight };
    case '9': return { x: defaultX + targetWidth, y: defaultY + targetHeight };
    default: return { x: defaultX + targetWidth, y: defaultY };
  }
}

export function calculatePosition(element, stageRef, scale) {
  if (!element) return;
  const absolutePosition = element.absolutePosition();
  return {
    x: (absolutePosition.x - stageRef.x()) / scale,
    y: (absolutePosition.y - stageRef.y()) / scale,
  };
}

export function isParentGroupElement(element) {
  return element?.parent?.getAttr('elementType') === 'group';
}
